import * as tslib_1 from "tslib";
import { AfterViewInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
var FormlyWrapperAddons = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyWrapperAddons, _super);
    function FormlyWrapperAddons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormlyWrapperAddons.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.matPrefix) {
            Promise.resolve().then(function () { return _this.to.prefix = _this.matPrefix; });
        }
        if (this.matSuffix) {
            Promise.resolve().then(function () { return _this.to.suffix = _this.matSuffix; });
        }
    };
    FormlyWrapperAddons.prototype.addonRightClick = function ($event) {
        if (this.to.addonRight.onClick) {
            this.to.addonRight.onClick(this.to, this, $event);
        }
    };
    FormlyWrapperAddons.prototype.addonLeftClick = function ($event) {
        if (this.to.addonLeft.onClick) {
            this.to.addonLeft.onClick(this.to, this, $event);
        }
    };
    return FormlyWrapperAddons;
}(FieldWrapper));
export { FormlyWrapperAddons };
/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */ 
